
    import Ember from 'ember';
    import "coffeescripts/ember/shared/helpers/common";

    Ember.TEMPLATES['aria_announcer'] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data
) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1;


  data.buffer.push("<div\n  class=\"aria-announcer hide-text affix\"\n  aria-live=\"polite\"\n  aria-atomic=\"true\"\n  aria-relative=\"all\"\n>\n  ");
  stack1 = helpers._triageMustache.call(depth0, "ariaAnnounced", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("\n</div>");
  return buffer;
  
});
  